export default "__VITE_ASSET__C2LH8JI7__"